import {useAutoForm} from '../../../components/AutoForm/useAutoForm';
import {builderFieldsType} from '../CreateBuilder/builderFields';
import {BuilderPot} from '../../../schema-types/BuilderPot';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {useContributionPotsQuery} from '../BuilderContribute/useContributionPotsQuery';
import {useWithdrawalPotsQuery} from '../BuilderWithdrawal/useWithdrawalPotsQuery';
import {useTransferPotsQuery} from '../BuilderTransfer/useTransferPotsQuery';
import {useModifyPotsQuery} from '../BuilderModify/useModifyPotsQuery';
import {useAdHocFeePotsQuery} from '../BuilderAdHocFee/useAdHocFeePotsQuery';

export const useBuilderPotsQuery = (): {
  sourcePots: BuilderPot[];
  destinationPots: BuilderPot[];
} => {
  const {values} = useAutoForm<builderFieldsType>();
  const contribute = useContributionPotsQuery();
  const withdraw = useWithdrawalPotsQuery();
  const transfer = useTransferPotsQuery();
  const modify = useModifyPotsQuery();
  const adHocFee = useAdHocFeePotsQuery();

  switch (values.planAction) {
    case OVRecommendActionEnum.CONTRIBUTE:
      return contribute;
    case OVRecommendActionEnum.WITHDRAW:
      return withdraw;
    case OVRecommendActionEnum.TRANSFER:
      return transfer;
    case OVRecommendActionEnum.MODIFY:
      return {sourcePots: modify.sourcePots, destinationPots: []};
    case OVRecommendActionEnum.AD_HOC_FEE:
      return {sourcePots: adHocFee.sourcePots, destinationPots: []};
    default:
      return {sourcePots: [], destinationPots: []};
  }
};
